import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Whatsapp from "../assets/images/Whatsapp.svg";
import Telegram from "../assets/images/Telegram.svg";
import Instagram from "../assets/images/Instagram.svg";
import SpribePrvdrImg from "../assets/images/providers/spribe-prvdr-img.svg";
import VivoPrvdrImg from "../assets/images/providers/vivo-prvdr-img.svg";
import EvolutionPrvdrImg from "../assets/images/providers/evolution-prvdr-img.svg";
import EzugiPrvdrImg from "../assets/images/providers/ezugi-prvdr-img.svg";
import RNG from "../assets/images/providers/rng-certified.png";
import Gambling from "../assets/images/providers/gambling-commission.png";
import ResponsibleG from "../assets/images/providers/responsible-gaming.png";
import Gamble18 from "../assets/images/providers/gamble-resp-18.png";

import Aviator from "../assets/images/games-icon/Aviator.png";
import Ezugi from "../assets/images/games-icon/headicon/ezugi.png";
import Sports from "../assets/images/games-icon/headicon/sports.png";
import Evolution from "../assets/images/games-icon/headicon/evolution.png";
import HomeIcon from "../assets/images/games-icon/headicon/house.png";

import BasicLargeAttentionSeal from "../assets/images/basic-large-attention-seal.png";
import Age18Plus from "../assets/images/age18+.svg";

const BeforeLoginFooter = () => {
  const navigate = useNavigate();
  const { appDetails } = useSelector((state) => state.app);

  return (
    <footer className="footer">
      <div className="inner-content">
        <div className="container">
          <div className="providers-sec">
            <div className="providers_img">
              <a href="javascript:void(0)">
                <img src={SpribePrvdrImg} loading="lazy" alt="spribe" />
              </a>
              <a href="javascript:void(0)">
                <img src={RNG} loading="lazy" alt="RNG Certified" />
              </a>
              <a href="javascript:void(0)">
                <img src={Gambling} loading="lazy" alt="Gambling Commission" />
              </a>
              <a href="javascript:void(0)">
                <img src={VivoPrvdrImg} loading="lazy" alt="vivo" />
              </a>
              <a href="javascript:void(0)">
                <img
                  src={ResponsibleG}
                  loading="lazy"
                  alt="Responsible Gaming"
                />
              </a>
              <a href="javascript:void(0)">
                <img src={EvolutionPrvdrImg} loading="lazy" alt="evolution" />
              </a>
              <a href="javascript:void(0)">
                <img src={Gamble18} loading="lazy" alt="Gamble Responsible" />
              </a>
              <a href="javascript:void(0)">
                <img src={EzugiPrvdrImg} loading="lazy" alt="ezugi" />
              </a>
            </div>
          </div>

          <div className="payments">
            <div className="inner-wrapper"></div>
          </div>

          <div className="foot-menu">
            <div className="inner-wrapper">
              <div className="left-content">
                <ul>
                  <li className="d-none d-md-block">
                    <a href="javascript:void(0)">Affiliates</a>
                  </li>
                  <li>
                    <a href="/contactus">Contact Us</a>
                  </li>
                  <li>
                    <a href="/privacypolicy ">Privacy Policy</a>
                  </li>
                  <li>
                    <a href="/responsiblegame">Responsible Gaming</a>
                  </li>
                </ul>
              </div>
              <div className="right-content">
                <ul>
                  <li>
                    <a href="/fairplay">Fair Play</a>
                  </li>
                  <li>
                    <a href="/gamesrule">Games Rules</a>
                  </li>
                  <li>
                    <a href="/terms">Terms and Conditions</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="foot-logo">
            <a href="/home">
              <img src={appDetails?.LOGO_URL} alt="Logo" />
            </a>
          </div>

          <div className="license">
            <div className="lic-logo logo1">
              <a href="javascript:void(0)">
                <img
                  src={BasicLargeAttentionSeal}
                  alt="basic large attention seal"
                />
              </a>
            </div>
            <div className="lic-logo logo2">
              <a href="javascript:void(0)">
                <img src={Age18Plus} alt="age 18 plus" />
              </a>
            </div>
          </div>

          <div className="disclaimer">
            <div className="disclamer">{appDetails?.FOOTER_TEXT || ""}</div>

            <div className="copyright">
              &copy; Moneymaker. All rights reserved.
            </div>
          </div>

          <div className="copyright-socials">
            <div className="copyright">
              &copy; Moneymaker. All rights reserved.
            </div>
            <div className="socials">
              <div className="inner-container">
                <p>Reach us</p>
                <div className="social">
                  <a
                    href={
                      appDetails?.WHATS_APP_URL != ""
                        ? appDetails?.WHATS_APP_URL
                        : "#"
                    }
                    target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                  >
                    <img src={Whatsapp} alt="whatsapp" />
                  </a>
                  <a
                    href={
                      appDetails?.INSTATGRAM != ""
                        ? appDetails?.INSTATGRAM
                        : "#"
                    }
                    target={appDetails?.INSTATGRAM != "" ? "_blank" : ""}
                  >
                    <img src={Instagram} alt="instagram" />
                  </a>
                  <a
                    href={
                      appDetails?.FACEBOOK != "" ? appDetails?.FACEBOOK : "#"
                    }
                    target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                  >
                    <img src="/images/facebook-512.svg" alt="facebook" />
                  </a>
                  <a
                    href={
                      appDetails?.TELEGRAM != "" ? appDetails?.TELEGRAM : "#"
                    }
                    target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                  >
                    <img src={Telegram} alt="telegram" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="language">
            <div className="lang"></div>
          </div>
        </div>

        <div className="footer-menu position-fixed start-0 bottom-0 z-index-2 w-100 d-block d-md-none d-none">
          <ul className="d-flex justify-content-evenly m-0 p-0 list-unstyled">
            <li>
              <a
                href=""
                onClick={() => {
                  navigate("/sign-in");
                }}
              >
                <img src={Sports} alt="sports" />
                <span>Sports</span>
              </a>
            </li>
            <li>
              <a
                href=""
                onClick={() => {
                  navigate("/sign-in");
                }}
              >
                <img src={Evolution} alt="evolution" />
                <span>Evolution</span>
              </a>
            </li>
            <li>
              <a className="active" href="/">
                <img src={HomeIcon} alt="home" />
                <span>Home</span>
              </a>
            </li>
            <li>
              <a
                href=""
                onClick={() => {
                  navigate("/sign-in");
                }}
              >
                <img src={Ezugi} alt="ezugi" />
                <span>Ezugi</span>
              </a>
            </li>
            <li>
              <a
                href=""
                onClick={() => {
                  navigate("/sign-in");
                }}
              >
                <img src={Aviator} alt="aviator" />
                <span>Aviator</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default BeforeLoginFooter;
